import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, forwardRef, ChangeDetectionStrategy } from '@angular/core';
import { DTypeFormEmbeddedItemField } from '@grupo-constant/next-dtype/form';
import { DTypeViewableCol } from '@grupo-constant/next-dtype/types';
import { DTypeFormFieldComponent } from '../../dtype-field.model';
import { DtypeItemComponent } from '../../dtype-item/dtype-item.component';
import { LocalizePipe } from '../../../pipes/standalone/localize.pipe';

@Component({
    selector: 'item-field-component',
    templateUrl: './item-field.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, LocalizePipe, forwardRef(() => DtypeItemComponent)]
})
export class DtypeItemFieldComponent implements DTypeFormFieldComponent, OnInit {

    @Input() field: DTypeFormEmbeddedItemField;
    @Input() isUpdate: boolean;
    @Input() useSummaryView: boolean;

    constructor() { }

    ngOnInit() {
        const readonlyOnUpdate = (this.field.dTypeCol as DTypeViewableCol).readonlyOnUpdate;
        if (readonlyOnUpdate && this.isUpdate) {
            this.field.readonly = true;
        }
    }

}
